import { isArray, isEmpty, isNumber } from "lodash-es";
import React, { useEffect, useRef, useState } from "react";
import { classnames } from "../../utils/text";
import DataComponent from "../DataComponent";
import Icon from "../Icon";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
import DeleteButton from "../../assets/images/icon/delete-btn.svg";
import EditButton from "../../assets/images/icon/edit-btn.svg";
import FaceButton from "../../assets/images/icon/face-icon.svg";
import Button from "../Button";
import { isFunction } from "lodash";


export default ({
  fields,
  list,
  isLoading,
  loadingColor,
  buttons,
  title,
  status,
  controller,
}) => {
  const table = useRef(null);
  const [tableHeight, setTableHeight] = useState(200);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        if (table && table.current) {
          setTableHeight(table.current.offsetHeight);
        }
      }, 500);
    }
  }, [isLoading]);

  return (
    <div className="financial-table">
      <div className="financial-table-header">
        {title && <span className="financial-table-title">{title}</span>}
        <div className="status-container">
          {list && (
            <div className="status-wrap">
              <span className="status-label">전체</span>
              <span className="status-value">{list.length}</span>
            </div>
          )}
          {status && (
            <>
              {isNumber(status.use) && (
                <div className="status-wrap">
                  <span className="status-label">사용</span>
                  <span className="status-value color-purple-100">
                    {status.use}
                  </span>
                </div>
              )}
              {isNumber(status.normal) && (
                <div className="status-wrap">
                  <span className="status-label">정상</span>
                  <span className="status-value color-green-100">
                    {status.normal}
                  </span>
                </div>
              )}
              {isNumber(status.error) && (
                <div className="status-wrap">
                  <span className="status-label">오류</span>
                  <span className="status-value color-red-100">
                    {status.error}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
        {isArray(buttons) &&
          buttons.map((button, idx) => (
            <DataComponent
              key={idx}
              field={{
                type: "button",
                ...button,
              }}
            />
          ))}
      </div>
      <div className="table-body">
        {isLoading ? (
          <Loading color={loadingColor} minHeight={tableHeight} />
        ) : isEmpty(list) ? (
          <NoData />
        ) : (
          <table ref={table}>
            <colgroup>
              <col width="18%"></col>
              <col width="20%"></col>
              {controller && controller.controlButton && (<col width="12%"></col>)}
              <col width="50%"></col>
            </colgroup>
            <tbody>
              {!isEmpty(list) &&
                list.map((data, idx) => (
                  <tr key={idx}>
                    {fields.map((field, idx) => (
                      <td className={field.className || ""} key={idx}>
                        <DataComponent field={field} data={data} />
                      </td>
                    ))}
                    {controller && (
                      <>
                        {controller.controlButton && (
                          <td className="control-button-td">
                            <Button
                              className="control-button"
                              color="text"
                              children={() => controller.controlButton.label(data)}
                              action={() => controller.controlButton.action(data)}
                            />
                          </td>
                        )}
                        <td className="row-btn-td">
                          {controller.setUsingAction &&
                            <DataComponent
                              field={{
                                className: controller.setScrapAction ? "margin-right-16" : "margin-right-56",
                                type: "switch",
                                label: "사용여부",
                                checked: data.isUsing === 1,
                                onChange: (e) => {
                                  controller.setUsingAction(e.target.checked, data.idx)
                                },
                                disabled: controller.switchDisabled
                              }}
                            />
                          }
                          {controller.setScrapAction &&
                            <DataComponent
                              field={{
                                className: "margin-right-56",
                                type: "switch",
                                label: "자동수집",
                                checked: data.isScrap === 1,
                                onChange: (e) => {
                                  controller.setScrapAction(e.target.checked, data.idx)
                                },
                                disabled: controller.switchDisabled
                              }}
                            />
                          }
                          {isArray(controller.rowButtons) &&
                            controller.rowButtons.map((btn, indexKey) => (
                              (isFunction(btn.isHide) && btn.isHide()) ||
                                (!isFunction(btn.isHide) && btn.isHide) ?
                                <React.Fragment key={`hide-${indexKey}`}></React.Fragment>
                                :
                                <React.Fragment key={indexKey}>
                                  {btn.type === "delete" && (
                                    <button
                                      className={classnames(
                                        "icon-button",
                                        btn.className
                                      )}
                                      type="button"
                                      onClick={() => btn.action(data)}
                                      disabled={btn.disabled}
                                    >
                                      <Icon src={DeleteButton} />
                                    </button>
                                  )}
                                  {btn.type === "edit" && (
                                    <button
                                      className={classnames(
                                        "icon-button",
                                        btn.className
                                      )}
                                      type="button"
                                      onClick={() => btn.action(data)}
                                      disabled={btn.disabled}
                                    >
                                      <Icon src={EditButton} />
                                    </button>
                                  )}
                                  {btn.type === "nickname" && (
                                    <button
                                      className={classnames(
                                        "icon-button",
                                        btn.className
                                      )}
                                      type="button"
                                      onClick={() => btn.action(data)}
                                      disabled={btn.disabled}
                                    >
                                      <Icon src={FaceButton} />
                                    </button>
                                  )}
                                </React.Fragment>
                            ))}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
